import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'profileFilterPipe'
})
export class ProfileFilterPipe implements PipeTransform {

  transform(value: any): any {
      let output = !_.isUndefined(value)? value : "";
      if(output.length > 15) {
          return output.substring(0, 15) + "...";
      } else {
          return output;
      }
  }

}
